module.exports = __webpack_public_path__ + "static/media/DSC09909.b3fcd5ac.jpg";